import { fetch } from '@maxtropy/components';

export function getDefaultKey(): Promise<Record<string, string>> {
  return fetch(`/api/file-center/defaultKey`);
}
